<template lang="pug">
  .module-units-view
    v-alert(
      v-if="moduleItem.prior_records_exists"
      type="info"
      color="secondary"
      prominent
      text
    ) Вы не можете удалять и добавлять новые темы
      |  поскольку ваш модуль уже используется организациями
    unit-management(
      :module-item="moduleItem"
      :method="getUnits"
      :can-create-unit="!moduleItem.prior_records_exists"
      :can-delete-unit="!moduleItem.prior_records_exists"
    )
</template>

<script>
import UnitManagement from '@/components/Unit/UnitManagement.vue';

export default {
  components: {
    UnitManagement,
  },
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
  },
  methods: {
    getUnits() {
      return this.$api.modules.courseUnits(this.moduleItem.id, {
        expand: 'lessons,tasks',
      });
    },
  },
};
</script>
